import React, { useState, useEffect } from 'react';
import './roll.scss';

function Roll (props){
    const {number} = props
    const [flag, setFlag] = useState(true)
    const [die, setDie] = useState('?')

    function numHandler(){
        setFlag(flag ? false : true)
        if(die !== '?'){
            setDie('?')
        }
        let count = 4;
        let number = setInterval( function(){
               count = count - 1
               if(count == 0){
                    clearInterval(number);
                    setDie(Math.ceil(Math.random() * 6))
                    setFlag(true)
                }
            }, 1000
        )
    }



    console.log(number)
    return (
        <React.Fragment>
            <div class={ flag ? 'nospin': 'box'}>
                <div class="cube">
                    <div class="side  front" onClick={()=> numHandler()}>{die}</div>
                    <div class="side   back">{number[1]}</div>
                    <div class="side  right">{number[2]}</div>
                    <div class="side   left">{number[3]}</div>
                    <div class="side    top">{number[4]}</div>
                    <div class="side bottom">{number[5]}</div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Roll;